import React, { useEffect, useState, useContext } from "react";
import {
  getClientDomain,
  getToken,
  getUser,
  translate,
  verifyHideCountryItems,
} from "../../../utils/Common";
// stylesheet
import "./index.css";
import styles from "./index.module.css";
// components
import FormPersonalInformation from "./FormPersonalInformation";
import FormUpdatePasswords from "./FormUpdatePasswords";
import FormBusinesslInformation from "./FormBusinesslInformation";
import FormBankInformation from "./FormBankInformation";
import AuthContext from "../../../contexts/auth";
import PageContainer from "../../../components/layout/PageContainer";
import PageHeader from "../../../components/layout/PageHeader";
import ContentCard from "../../../components/layout/ContentCard";
import { ConfirmModal } from "../../../components/common/ConfirmModal";

// icons
import * as FaIcons from "react-icons/fa";
import * as FiIcons from "react-icons/fi";
import { BsPerson } from "react-icons/bs";

const UserProfile = (props) => {
  const [userInformation, setUserInformation] = useState();

  const UserContext = useContext(AuthContext);

  const [getUserInfo, setGetUserInfo] = useState(false);
  const [validateUpdatePwd, setValidateUpdatePwd] = useState(false);
  const [validateUpdatePwdLocker, setValidateUpdatePwdLocker] = useState(false);
  const [isLockerPwdVisible, setIsLockerPwdVisible] = useState(false);
  const [lockerConfirmOpen, setLockerConfirmOpen] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();

    const getUserInformation = async () => {
      try {
        const response = await fetch(
          `${getClientDomain(2)}/users/s/${getUser(2).IdCliente}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${getToken()}`,
            },
            signal: abortController.signal,
          }
        );

        const result = await response.json();
        if (result?.code === 200)
          if (result?.payload) setUserInformation(result.payload);
      } catch (error) {
        console.log(error);
      }
    };

    getUserInformation();
    return () => abortController.abort();
  }, [getUserInfo]);

  return (
    <PageContainer>
      <PageHeader
        title={translate("dashboard.userprofile.personal.title")}
        subtitle={translate("dashboard.userprofile.personal.subtitle") || "Manage your personal and business information"}
        icon={<BsPerson size={28} />}
      />

      <div className={styles.cardsContainer}>
        {/* Business Information Section */}
        <ContentCard
          title={translate("dashboard.userprofile.business.title")}
          padding="lg"
        >
          <FormBusinesslInformation
            userInformation={userInformation}
            validateUpdatePwd={validateUpdatePwd}
            validateUpdatePwdLocker={validateUpdatePwdLocker}
            setValidateUpdatePwdLocker={setValidateUpdatePwdLocker}
          />

          {/* Form to update password */}
          {validateUpdatePwdLocker && (
            <div style={{ marginTop: '1.5rem' }}>
              <FormUpdatePasswords
                getUserInfo={getUserInfo}
                setGetUserInfo={setGetUserInfo}
                userInformation={userInformation}
                validateUpdatePwd={validateUpdatePwd}
                setValidateUpdatePwd={setValidateUpdatePwd}
                validateUpdatePwdLocker={validateUpdatePwdLocker}
                setValidateUpdatePwdLocker={setValidateUpdatePwdLocker}
              />
            </div>
          )}
        </ContentCard>

        {/* Personal Information Section */}
        <ContentCard
          title={translate("dashboard.userprofile.personal.title")}
          padding="lg"
        >
        <FormPersonalInformation
          userInformation={userInformation}
          updateSidebarInfo={props.updateSidebarInfo}
          setValidateUpdatePwd={setValidateUpdatePwd}
          validateUpdatePwdLocker={validateUpdatePwdLocker}
          validateUpdatePwd={validateUpdatePwd}
          setValidateUpdatePwdLocker={setValidateUpdatePwdLocker}
        />

        {/* Form to update password */}
        {validateUpdatePwd && (
          <div style={{ marginTop: '1.5rem' }}>
            <FormUpdatePasswords
              userInformation={userInformation}
              validateUpdatePwdLocker={validateUpdatePwdLocker}
              setValidateUpdatePwdLocker={setValidateUpdatePwdLocker}
              validateUpdatePwd={validateUpdatePwd}
              setValidateUpdatePwd={setValidateUpdatePwd}
            />
          </div>
        )}

        {/* Locker Credentials Section */}
        {!UserContext.user.IsAdmin && verifyHideCountryItems(["us"]) && (
          <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--border-light)' }}>
            <h5 style={{ marginBottom: '1.5rem', fontSize: '1.125rem', fontWeight: 600 }}>
              {translate("dashboard.userprofile.business.credLocker")}
            </h5>
            <div className="flex flex-wrap text-left">
              <div className="md:w-6/12 mb-3">
                <label htmlFor="inputUsuario" style={{ marginBottom: '0.5rem', display: 'block', fontWeight: 500 }}>
                  {translate("dashboard.userprofile.business.user")}:
                </label>
                <div className="flex w-full items-stretch">
                  <div className="flex items-center">
                    <span className="flex items-center px-3 text-muted-foreground" id="inputUsuario">
                      <FaIcons.FaUser size={16} />
                    </span>
                  </div>
                  <input
                    value={
                      userInformation
                        ? Number(userInformation.IdUsuario) < 99
                          ? `0${userInformation.IdUsuario}`
                          : userInformation.IdUsuario
                        : ""
                    }
                    disabled
                    type="text"
                    className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed"
                    id="inputUsuario"
                  />
                </div>
              </div>
              {!validateUpdatePwdLocker && !validateUpdatePwd && (
                <>
                  <div className="md:w-6/12 mb-3">
                    <label htmlFor="inputClave" style={{ marginBottom: '0.5rem', display: 'block', fontWeight: 500 }}>
                      {translate("dashboard.userprofile.business.password")}:
                    </label>
                    <div className="flex w-full items-stretch">
                      <div className="flex items-center">
                        <span
                          className="flex items-center px-3 text-muted-foreground span-eye-pwd"
                          onClick={() => setIsLockerPwdVisible(!isLockerPwdVisible)}
                          style={{ cursor: 'pointer' }}
                        >
                          {!isLockerPwdVisible ? (
                            <FiIcons.FiEye size={16} className="text-dark" />
                          ) : (
                            <FiIcons.FiEyeOff size={16} className="text-dark" />
                          )}
                        </span>
                      </div>
                      <input
                        value={
                          userInformation
                            ? Buffer.from(userInformation.Clave, "base64").toString(
                                "ascii"
                              )
                            : ""
                        }
                        disabled
                        type={isLockerPwdVisible ? "text" : "password"}
                        className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed"
                        id="inputClave"
                      />
                    </div>
                  </div>

                  <div className="w-full mb-3">
                    <div className="flex flex-wrap mb-0">
                      <div className="w-full mb-0 text-left">
                        <p className="mb-2" style={{ color: 'var(--text-secondary)' }}>
                          {translate("dashboard.userprofile.business.instructions")}.
                        </p>

                        <button
                          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs btn-hide"
                          type="button"
                          onClick={() => setLockerConfirmOpen(true)}
                        >
                          <span className="font-semibold">
                            {translate(
                              "dashboard.userprofile.business.buttonCredLocker"
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Form to update password */}
            {validateUpdatePwdLocker && !UserContext.user.IsAdmin && (
              <div style={{ marginTop: '1.5rem' }}>
                <FormUpdatePasswords
                  getUserInfo={getUserInfo}
                  setGetUserInfo={setGetUserInfo}
                  userInformation={userInformation}
                  validateUpdatePwd={validateUpdatePwd}
                  setValidateUpdatePwd={setValidateUpdatePwd}
                  validateUpdatePwdLocker={validateUpdatePwdLocker}
                  setValidateUpdatePwdLocker={setValidateUpdatePwdLocker}
                />
              </div>
            )}
          </div>
        )}

        {/* Bank Information Section */}
        {verifyHideCountryItems(["us", "br"]) && (
          <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--border-light)' }}>
            <FormBankInformation userInformation={userInformation} />
          </div>
        )}
      </ContentCard>
      </div>

      <ConfirmModal
        isOpen={lockerConfirmOpen}
        onClose={() => setLockerConfirmOpen(false)}
        onConfirm={() => {
          setLockerConfirmOpen(false);
          setValidateUpdatePwdLocker(true);
        }}
        title={translate("dashboard.userprofile.business.modal.title") + "!"}
        message={translate("dashboard.userprofile.business.modal.description")}
        confirmText={translate("dashboard.userprofile.business.modal.accept")}
        cancelText={translate("dashboard.userprofile.business.modal.cancel")}
        variant="primary"
      />
    </PageContainer>
  );
};

export default UserProfile;
